import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { bars as Bars } from '@breezeway/brzw-components';

import { refactorData, renderFirstLabel } from '../../utils/assignment_bar';

const AvailabilityBar = ({ label, withHourLabels, personAvailability, withAsideHourLabels }) => {
  const data = refactorData(personAvailability);
  const newLabel = label || (_.isEmpty(data) ? 'No availability' : '');
  const defaultSubtitle = '0:00';

  return (
    <Bars.AvailabilityBar
      data={data}
      subtitle={_.isEmpty(data) ? defaultSubtitle : renderFirstLabel(data, 'availability')}
      title="A:"
      label={newLabel}
      withAsideHourLabels={withAsideHourLabels}
      withHourLabels={withHourLabels}
    />
  );
};

AvailabilityBar.propTypes = {
  label: PropTypes.string,
  personAvailability: PropTypes.arrayOf(PropTypes.shape()),
  withAsideHourLabels: PropTypes.bool,
  withHourLabels: PropTypes.bool,
};

export default AvailabilityBar;
